import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import windowSize from "react-window-size";

import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import PropTypes from "prop-types";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import loader from "../../images/Spin-1s-107px.gif";
import {
  getAllSettlementListOfUserById,
  getAllSettlementListOfUserByIdForGroup,
  getBarGraphDataForDashboard
} from "../../Actions/actions";
import * as moment from "moment";
import BigMoney from "../common/bigMoney";
import Tooltip from '@material-ui/core/Tooltip';

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired
};

const activeTab = (val, t) => {
  if (val === t) {
    return "settlements-tabs settlements-tabs-active";
  }
  return "settlements-tabs";
};

class dashboardSettlementDetailsByGroups extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: localStorage.getItem("userId"),
      value: 0,
      isLoader: false
    };
  }

  async componentDidMount() {
    const { userId } = this.state;
    const {
      getBarGraphDataForDashboard,
      getAllSettlementListOfUserById,
      getAllSettlementListOfUserByIdForGroup,
      match: { params }
    } = this.props;
    this.setState({
      isLoader: true
    });
          // await getBarGraphDataForDashboardWithSettlementIdForParentUserForGroup({
      //   userId,
      //   settlementId: params && params.id,
      //   groupId: params && params.groupId
      // });
      await getAllSettlementListOfUserByIdForGroup({ userId, id: params && params.id,groupId: params && params.groupId,partnerId : params && params.partnerId });
            this.setState({
        isLoader: false
      });
    // if(params && params.groupId){
    //   console.log('params.groupId', params.groupId)
    //   // await getBarGraphDataForDashboardWithSettlementIdForParentUserForGroup({
    //   //   userId,
    //   //   settlementId: params && params.id,
    //   //   groupId: params && params.groupId
    //   // });
    //   await getAllSettlementListOfUserByIdForGroup({ userId, id: params && params.id,groupId: params && params.groupId });
  
    //   this.setState({
    //     isLoader: false
    //   });
    // }else{
    //   await getBarGraphDataForDashboard({
    //     userId,
    //     settlementId: params && params.id
    //   });
    //   await getAllSettlementListOfUserById({ userId, id: params && params.id });
  
    //   this.setState({
    //     isLoader: false
    //   });
    // }

    // await this.props.getAffiliateUser(userid);
  }

  handleChange = (e, v) => {
    this.setState({ value: v });
  };

  render() {
    const { value, isLoader } = this.state;
    const {
      data: {getAllSettlementListOfUserByIdForGroupData },
      windowWidth
    } = this.props;
    const regex = /(<([^>]+)>)/ig;
    let sortable = [];

    function sortObject(obj) {
      const arr = [];
      const text = {
        hideFundsInEscrow: 'Funds in Escrow',
        hideOptOutDeadline: 'Opt Out Deadline',
        hideFairnessHearing: 'Fairness Hearing',
        hideClaimPeriodEnd: 'Claim Filing Deadline',
        hideClaimPeriodStart: 'Claim Filing Start',
        classPeriodStart: 'Class Period Start',
        classPeriodEnd: 'Class Period End',
        hideFundsDisbursement: 'Funds Disbursement',
        hideCaseApproval: 'Final Approval',
        hideClassAction: 'Class Action',
        hideGuiltyPlea: 'Guilty Plea',
        hideInitialApproval: 'Initial Approval',
        hideInvestigation: 'Investigation',
        hideLitigation: 'Litigation',
        hideSettlement: 'Settlement',
      };
      const tooltipList = {
        hideFundsInEscrow: 'Funds in Escrow',
        hideOptOutDeadline: 'The exclusion request is the formal request from a class member to be removed from the class. Some class actions allow a class member to opt out of the class. This may be because the class member thinks he/she can get a better result on his/her own or because the class member doesn t want to be involved. An Opt-Out is similar to an exclusion request. It is the act of one class member electing not to be part of the class-action lawsuit.',
        hideFairnessHearing: 'When an antitrust or class-action lawsuits is settled, there are often thousands or even millions of class members. The trial judge in many cases holds a fairness hearing to determine if the settlement is fair.',
        hideClaimPeriodStart: 'When a settlement receives final approval, court notices are sent out to class members notifying them that they may be eligible to receive a refund from the class action settlement. The notice announces the period in which claims must be filed. The filing deadline is the last day to submit claims.',
        hideClaimPeriodEnd: 'When a settlement receives final approval, court notices are sent out to class members notifying them that they may be eligible to receive a refund from the class action settlement. The notice announces the period in which claims must be filed. The filing deadline is the last day to submit claims.',
        hideFundsDisbursement: 'Once a settlement concludes and the submitted claims have been reviewed, audited, evaluated for their pro rata payment, and all objections and appeals are done, the court will receive and eventually approve a Motion to Distribute',
        hideCaseApproval: 'Once a settlement is proposed to the court, a Judge grants an Initial Approval. The Judge then listens to arguments to determine a settlement’s fairness. When the Judge determines the settlement to be Fair, he or she will grant a Final Approval',
        hideClassAction: 'This is the specific time frame during which a defendant company is alleged to have been improperly conducting the business that caused the lawsuit. The class period is spelled out in court documents and in the public notice about the settlement. Even if the anticompetitive activities are alleged to have taken place over a longer period of time, a finite settlement period is agreed upon to facilitate the settlement and the administration of submitted claims.',
        hideGuiltyPlea: 'Guilty Plea',
        hideInitialApproval: ' Once a settlement is proposed to the court, a Judge grants an Initial Approval. The Judge will then listen to arguments as to the settlements fairness prior to giving a Final Approval',
        hideInvestigation: 'Investigation',
        hideLitigation: 'Litigation',
        hideSettlement: 'Settlement',
        classPeriodEnd: 'This is the specific time frame during which a defendant company is alleged to have been improperly conducting the business that caused the lawsuit. The class period is spelled out in court documents and in the public notice about the settlement.  Even if the anticompetitive activities are alleged to have taken place over a longer period of time, a finite settlement period is agreed upon to facilitate the settlement and the administration of submitted claims.​',
        classPeriodStart: 'This is the specific time frame during which a defendant company is alleged to have been improperly conducting the business that caused the lawsuit. The class period is spelled out in court documents and in the public notice about the settlement.  Even if the anticompetitive activities are alleged to have taken place over a longer period of time, a finite settlement period is agreed upon to facilitate the settlement and the administration of submitted claims.​',
      };
      // let notIn = ['initialApproval','hideSettlement','settlement','hideGuiltyPlea','guiltyPlea','hideClassAction','classAction','hideLitigation','litigation','caseApproval','fairnessHearing','hideCaseApproval','hideInvestigation']
      for (const prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          if (obj[prop] !== 1) {
            if (text.hasOwnProperty(prop)) {
              arr.push({
                key: prop,
                value: obj[prop],
                displayText: text[prop],
                tooltipText: tooltipList[prop],
                display: 1,
              });
            } else {
              arr.push({
                key: prop,
                value: obj[prop],
                displayText: 'none',
                tooltipText: tooltipList[prop],
                display: 0,
              });
            }
          }
        }
      }
      arr.sort((a, b) => a.value - b.value);
      let findIndex;
      let findIndex1;
      let startDate;

      // let endDate;
      const modifyData = arr.map((value) => {
        switch (value.key) {
          case 'hideFundsInEscrow':
            findIndex = arr.findIndex(l => l.key === 'fundsInEscrow');
            value.value = moment(arr[findIndex].value).format('MM/DD/YYYY')
              === 'Invalid date'
              ? 'TBD'
              : moment(arr[findIndex].value).format('MM/DD/YYYY');
            return value;

          case 'classPeriodStart':
            findIndex = arr.findIndex(l => l.key === 'classPeriodStart');
            value.value = moment(arr[findIndex].value).format('MM/DD/YYYY')
              === 'Invalid date'
              ? 'TBD'
              : moment(arr[findIndex].value).format('MM/DD/YYYY');
            return value;

          case 'classPeriodEnd':
            findIndex = arr.findIndex(l => l.key === 'classPeriodEnd');
            value.value = moment(arr[findIndex].value).format('MM/DD/YYYY')
              === 'Invalid date'
              ? 'TBD'
              : moment(arr[findIndex].value).format('MM/DD/YYYY');
            return value;

          case 'hideOptOutDeadline':
            findIndex = arr.findIndex(l => l.key === 'optOutDeadline');
            value.value = moment(arr[findIndex].value).format('MM/DD/YYYY')
              === 'Invalid date'
              ? 'TBD'
              : moment(arr[findIndex].value).format('MM/DD/YYYY');
            return value;
          case 'hideClaimPeriodStart':
            findIndex = arr.findIndex(l => l.key === 'claimPeriodEnd');
            findIndex1 = arr.findIndex(l => l.key === 'claimPeriodStart');
            startDate = moment(arr[findIndex1].value).format('MM/DD/YYYY')
              === 'Invalid date'
              ? 'TBD'
              : moment(arr[findIndex1].value).format('MM/DD/YYYY');
            // endDate = moment(arr[findIndex].value).format('MM-DD-YYYY')
            // === 'Invalid date'
            //   ? 'TBD'
            //   : moment(arr[findIndex].value).format('MM-DD-YYYY');
            value.value = startDate;
            return value;
          case 'hideClaimPeriodEnd':
            findIndex = arr.findIndex(l => l.key === 'claimPeriodEnd');
            value.value = moment(arr[findIndex].value).format('MM/DD/YYYY')
              === 'Invalid date'
              ? 'TBD'
              : moment(arr[findIndex].value).format('MM/DD/YYYY');
            return value;

          case 'hideFairnessHearing':
            findIndex = arr.findIndex(l => l.key === 'fairnessHearing');
            value.value = moment(arr[findIndex].value).format('MM/DD/YYYY')
              === 'Invalid date'
              ? 'TBD'
              : moment(arr[findIndex].value).format('MM/DD/YYYY');
            return value;
          case 'hideFundsDisbursement':
            findIndex = arr.findIndex(l => l.key === 'fundsDisbursement');
            value.value = moment(arr[findIndex].value).format('MM/DD/YYYY')
              === 'Invalid date'
              ? 'TBD'
              : moment(arr[findIndex].value).format('MM/DD/YYYY');
            return value;

          case 'hideCaseApproval':
            findIndex = arr.findIndex(l => l.key === 'caseApproval');
            value.value = moment(arr[findIndex].value).format('MM/DD/YYYY')
              === 'Invalid date'
              ? 'TBD'
              : moment(arr[findIndex].value).format('MM/DD/YYYY');
            return value;
          case 'hideClassAction':
            findIndex = arr.findIndex(l => l.key === 'classAction');
            value.value = moment(arr[findIndex].value).format('MM/DD/YYYY')
              === 'Invalid date'
              ? 'TBD'
              : moment(arr[findIndex].value).format('MM/DD/YYYY');
            return value;
          case 'hideGuiltyPlea':
            findIndex = arr.findIndex(l => l.key === 'guiltyPlea');
            value.value = moment(arr[findIndex].value).format('MM/DD/YYYY')
              === 'Invalid date'
              ? 'TBD'
              : moment(arr[findIndex].value).format('MM/DD/YYYY');
            return value;
          case 'hideInitialApproval':
            findIndex = arr.findIndex(l => l.key === 'initialApproval');
            value.value = moment(arr[findIndex].value).format('MM/DD/YYYY')
              === 'Invalid date'
              ? 'TBD'
              : moment(arr[findIndex].value).format('MM/DD/YYYY');
            return value;
          case 'hideInvestigation':
            findIndex = arr.findIndex(l => l.key === 'investigation');
            value.value = moment(arr[findIndex].value).format('MM/DD/YYYY')
              === 'Invalid date'
              ? 'TBD'
              : moment(arr[findIndex].value).format('MM/DD/YYYY');
            return value;
          case 'hideLitigation':
            findIndex = arr.findIndex(l => l.key === 'litigation');
            value.value = moment(arr[findIndex].value).format('MM/DD/YYYY')
              === 'Invalid date'
              ? 'TBD'
              : moment(arr[findIndex].value).format('MM/DD/YYYY');
            return value;
          case 'hideSettlement':
            findIndex = arr.findIndex(l => l.key === 'settlement');
            value.value = moment(arr[findIndex].value).format('MM/DD/YYYY')
              === 'Invalid date'
              ? 'TBD'
              : moment(arr[findIndex].value).format('MM/DD/YYYY');
            return value;
          default:
        }

        return value;
      });
      const filterData = modifyData.filter(d => d.display === 1);
      return filterData;
    }
    if (typeof getAllSettlementListOfUserByIdForGroupData !== 'undefined') {
      if (typeof getAllSettlementListOfUserByIdForGroupData.settlementImportantDateDto === 'undefined') {
        if (getAllSettlementListOfUserByIdForGroupData.settlementDto !== undefined) {
          if (typeof getAllSettlementListOfUserByIdForGroupData.settlementDto.settlementImportantDateDto === 'undefined') {
            // sortable = sortObject(item.settlementImportantDateDto);
          } else {
            sortable = sortObject(getAllSettlementListOfUserByIdForGroupData.settlementDto.settlementImportantDateDto);
          }
        }
      } else {
        sortable = sortObject(getAllSettlementListOfUserByIdForGroupData.settlementImportantDateDto);
      }
    }

    if (typeof getAllSettlementListOfUserByIdForGroup !== 'undefined') {
      if (typeof getAllSettlementListOfUserByIdForGroup.settlementImportantDateDto === 'undefined') {
        if (getAllSettlementListOfUserByIdForGroup.settlementDto !== undefined) {
          if (typeof getAllSettlementListOfUserByIdForGroup.settlementDto.settlementImportantDateDto === 'undefined') {
            // sortable = sortObject(item.settlementImportantDateDto);
          } else {
            sortable = sortObject(getAllSettlementListOfUserByIdForGroup.settlementDto.settlementImportantDateDto);
          }
        }
      } else {
        sortable = sortObject(getAllSettlementListOfUserByIdForGroup.settlementImportantDateDto);
      }
    }


    // sortable.splice(1, 0, sortablesortable.splice(0, 1)[0])

    sortable.sort((a, b) => {
      const dateA = a.value !== 'TBD' ? new Date(`${a.value.split('-')[2]}-${a.value.split('-')[0]}-${a.value.split('-')[1]}`) : new Date('9999-10-10');
      const dateB = b.value !== 'TBD' ? new Date(`${b.value.split('-')[2]}-${b.value.split('-')[0]}-${b.value.split('-')[1]}`) : new Date('9999-10-10');

      return dateA - dateB;
      // }
      // return true;
    });
    const index = sortable.findIndex(l => l !== undefined && l.key === 'hideClaimPeriodStart') === -1 ? 2 : 3;
    sortable.splice(0, 0, sortable.splice(sortable.findIndex(l => l !== undefined && l.key === 'classPeriodStart'), 1)[0]);
    sortable.splice(1, 0, sortable.splice(sortable.findIndex(l => l !== undefined && l.key === 'classPeriodEnd'), 1)[0]);
    sortable.splice(2, 0, sortable.splice(sortable.findIndex(l => l !== undefined && l.key === 'hideClaimPeriodStart'), 1)[0]);
    sortable.splice(index, 0, sortable.splice(sortable.findIndex(l => l !== undefined && l.key === 'hideClaimPeriodEnd'), 1)[0]);

    //console.log(settlementUserIdAffiliateData.settlingDefendants, 'info');
    return (
      <div>
        {isLoader === true ? (
          <div className="loader">
            <img src={loader} alt="" />
          </div>
        ) : (
            ""
          )}
        <div className="p-settlement-detail">
          <div className="breadcrumbs">
            <span> Settlement</span>
            <span>></span>
            <span> {getAllSettlementListOfUserByIdForGroupData &&
              getAllSettlementListOfUserByIdForGroupData.shortName}{" "}</span>
            <span>></span>
            <span>
              <Link to={`${getAllSettlementListOfUserByIdForGroupData && getAllSettlementListOfUserByIdForGroupData.id}`}>
                Details
              </Link></span>
          </div>
          <div className="p-settlement-heading">
            <h3 className="p-h3">
              {getAllSettlementListOfUserByIdForGroupData &&
                getAllSettlementListOfUserByIdForGroupData.shortName}{" "}
            </h3>
            <p className="p-settlement-amount text-uppercase p-font-bold">
              Settlement Amount
              {getAllSettlementListOfUserByIdForGroupData && getAllSettlementListOfUserByIdForGroupData.tbdAmount !== "TBD" ? (<BigMoney
                value={
                    getAllSettlementListOfUserByIdForGroupData &&
                    getAllSettlementListOfUserByIdForGroupData.totalMoneyAvailable
                }
              />) : (<span> TBD</span>)}
            </p>
          </div>
        </div>
        {windowWidth > 600 ? (<Tabs
          value={this.state.value}
          onChange={this.handleChange}
          indicatorColor="transparent"
          className="settlements-details-tabs"
        >
          <Tab
            style={{ 'text-transform': 'none' }}
            className={activeTab(0, this.state.value)}
            label="Overview & Defendants"
          />
          <Tab
            style={{ 'text-transform': 'none' }}
            className={activeTab(1, this.state.value)}
            label="Eligibility & Benefits"
          />
          <Tab style={{ 'text-transform': 'none' }} className={activeTab(2, this.state.value)} label="Timeline" />
          <Tab
            style={{ 'text-transform': 'none' }}
            className={activeTab(3, this.state.value)}
            label="FAQ & Documents"
          />
        </Tabs>) : (
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              className="overview-settlement-dropdown"
              name="settlementId"
              value={this.state.value}
              onChange={event => {
                this.setState({ value: event.target.value })
              }}
            >
              <MenuItem className="overview-settlement-dropdown-value"
                value={0}>Overview & Defendants</MenuItem>
              <MenuItem className="overview-settlement-dropdown-value" value={1}>Eligibility & Benefits</MenuItem>
              <MenuItem className="overview-settlement-dropdown-value" value={2}>Timeline</MenuItem>
              <MenuItem className="overview-settlement-dropdown-value" value={3}>FAQ & Documents</MenuItem>

            </Select>

          )}

        {value === 0 && (
          <div className="settlements-details-tabs-data">
            <Typography className="p-h4">Overview</Typography>
            <div
              className="content settlement-detail-overview"
              dangerouslySetInnerHTML={{
                __html:
                getAllSettlementListOfUserByIdForGroupData &&
                getAllSettlementListOfUserByIdForGroupData.overview
              }}
            />
            <Typography className="p-h4">Defendants</Typography>
            <div
              className="content settlement-detail-overview"
            >

              {typeof getAllSettlementListOfUserByIdForGroupData !== 'undefined' ? getAllSettlementListOfUserByIdForGroupData.settlingDefendants !== '' || getAllSettlementListOfUserByIdForGroupData.settlingDefendantsDiscription.replace(regex, '').trim() !== ''

                ? (


                  <div style={{ width: '100%' }}>
                    <div>
                      {typeof getAllSettlementListOfUserByIdForGroupData.settlingDefendantsDiscription
                        !== 'undefined' && getAllSettlementListOfUserByIdForGroupData.settlingDefendantsDiscription.replace(regex, '').trim() !== '' ? (
                          <div>
                            <h6 className="heading-text">
                              Defendants Description:
</h6>

                            <div>
                              <div
                                className="content settlement-detail-overview"
                                dangerouslySetInnerHTML={{
                                  __html:
                                  getAllSettlementListOfUserByIdForGroupData.settlingDefendantsDiscription,
                                }}
                              />
                            </div>

                          </div>) : ''}


                      {typeof getAllSettlementListOfUserByIdForGroupData !== 'undefined' && getAllSettlementListOfUserByIdForGroupData.settlingDefendants !== '' ? (
                        <div>
                          <h6 className="heading-text">
                            Defendants List:
</h6>
                          {typeof getAllSettlementListOfUserByIdForGroupData.settlingDefendants
                            !== 'undefined' ? (
                              <div className="user-data">

                                <div className="user-data__row">{getAllSettlementListOfUserByIdForGroupData.settlingDefendants}</div>
                              </div>
                            ) : ''}
                        </div>
                      ) : ''}
                    </div>

                  </div>
                ) : 'No Defendant details available' : 'No Defendant details available'}
            </div>


          </div>


        )}

        {value === 1 && (
          <div
            className="content settlement-detail-overview"
          >
            <h6 className='heading-text'>Eligibility Criteria</h6>
            {console.log('settlementUserIdAffiliateData.settlementEligibilityCriteria', getAllSettlementListOfUserByIdForGroupData.eligibilityCriteria)}
            <span>{<div className="content settlement-detail-overview" dangerouslySetInnerHTML={{ __html: getAllSettlementListOfUserByIdForGroupData.eligibilityCriteria }}></div>}</span>
            <h6 className='heading-text'>Disclaimer</h6>
            <span>{<div className="content settlement-detail-overview" dangerouslySetInnerHTML={{ __html: getAllSettlementListOfUserByIdForGroupData.disclaimer }}></div>}</span>

            <div>
              <h6 className='heading-text' >Benefits details:</h6>
              {(typeof (getAllSettlementListOfUserByIdForGroupData) !== 'undefined') ?
                <div>
                  {(typeof (getAllSettlementListOfUserByIdForGroupData.settlementBenefitList) !== 'undefined') ?
                    <div>
                      {getAllSettlementListOfUserByIdForGroupData.settlementBenefitList.map((s, idx) => (
                        //  <div>{s.benefit}</div>
                        <Typography><div className="content" key={idx} dangerouslySetInnerHTML={{ __html: s.benefit }}></div></Typography>

                        //   <div className="content settlement-detail-overview" dangerouslySetInnerHTML={{__html: s.benefit}}> </div> 
                      ))}
                    </div>
                    : (
                      <div>No benefits added</div>
                    )}
                </div>
                : (
                  <div> No benefits added</div>
                )}
            </div>
          </div>
        )}
        {value === 2 && (
          <div>
            <div className="timeline row">
              <ul>

                {sortable.map(data => (
                  <li
                    className="timeline-text"
                    style={{
                      display: 'inline-block',
                    }}
                    key={data.key}
                  >
                    <div className="col s12 m6 left-align center">
                      <span>{data.displayText}</span>
                      {' '}
                      <Tooltip id="tooltip-icon" title={data.tooltipText}>
                        <label className="q-icon">
                          {' '}
                          <i className="small material-icons">help</i>
                        </label>
                      </Tooltip>
                    </div>
                    <div className="col s12 m6 right-align center">
                      {data.value}
                    </div>
                  </li>
                ))}

                {/* <li className='timeline-text' style={{ display: (settlementUserIdAffiliateData.hideClaimPeriodStart === 1) ? "none" : "inline-block" }}>
                  <div className="col s12 m6 left-align center"><span>Class Period</span> <Tooltip id="tooltip-icon" title="When a settlement receives final approval, court notices are sent out to class members notifying them that they may be eligible to receive a refund from the class action settlement. The notice announces the period in which claims must be filed. The filing deadline is the last day to submit claims.​"><label className="q-icon"> <i className="small material-icons">help</i></label></Tooltip></div>
                  <div
                    className="col s12 m6 right-align center">{moment(settlementUserIdAffiliateData.settlementImportantDateDto.classPeriodStart).format('MM-DD-YYYY') === 'Invalid date' ? 'TBD' : moment(settlementUserIdAffiliateData.settlementImportantDateDto.classPeriodStart).format('MM-DD-YYYY')} - {moment(settlementUserIdAffiliateData.settlementImportantDateDto.classPeriodEnd).format('MM-DD-YYYY') === 'Invalid date' ? 'TBD' : moment(settlementUserIdAffiliateData.settlementImportantDateDto.classPeriodEnd).format('MM-DD-YYYY')}</div>
                </li> */}
                {/*<li className='timeline-text'>
                                                        <div className="col s6 left-align">Claim Period End</div>
                                                        <div
                                                            className="col s6 right-align"></div>
                                                    </li>*/}
                {/* <li className='timeline-text' style={{ display: (settlementUserIdAffiliateData.settlementImportantDateDto.hideInitialApproval === 1) ? "none" : "inline-block" }}>
                  <div className="col s12 m6 left-align center"><span>Final Approval</span> <Tooltip id="tooltip-icon" title="Once a settlement is proposed to the court, a Judge grants an Initial Approval. The Judge then listens to arguments to determine a settlement’s fairness. When the Judge determines the settlement to be Fair, he or she will grant a Final Approval"><label className="q-icon"> <i className="small material-icons">help</i></label></Tooltip></div>

                  <div
                    className="col s12 m6 right-align center">{moment(settlementUserIdAffiliateData.settlementImportantDateDto.initialApproval).format('MM-DD-YYYY') === 'Invalid date' ? 'TBD' : moment(settlementUserIdAffiliateData.settlementImportantDateDto.initialApproval).format('MM-DD-YYYY')}</div>
                </li>
                <li className='timeline-text' style={{ display: (settlementUserIdAffiliateData.settlementImportantDateDto.hideFundsInEscrow === 1) ? "none" : "inline-block" }} >
                  <div className="col s12 m6 left-align center"><span>Funds in Escrow</span> <Tooltip id="tooltip-icon" title="Funds in Escrow"><label className="q-icon"> <i className="small material-icons">help</i></label></Tooltip></div>
                  <div
                    className="col s12 m6 right-align center">{moment(settlementUserIdAffiliateData.settlementImportantDateDto.fundsInEscrow).format('MM-DD-YYYY') === 'Invalid date' ? 'TBD' : moment(settlementUserIdAffiliateData.settlementImportantDateDto.fundsInEscrow).format('MM-DD-YYYY')}</div>
                </li>
                <li className='timeline-text' style={{ display: (settlementUserIdAffiliateData.settlementImportantDateDto.hideOptOutDeadline === 1) ? "none" : "inline-block" }} >
                  <div className="col s12 m6 left-align center"><span>Opt Out Deadline</span> <Tooltip id="tooltip-icon" title="The exclusion request is the formal request from a class member to be removed from the class. Some class actions allow a class member to opt out of the class. This may be because the class member thinks he/she can get a better result on his/her own or because the class member doesn't want to be involved. An Opt-Out is similar to an exclusion request. It is the act of one class member electing not to be part of the class-action lawsuit."><label className="q-icon"> <i className="small material-icons">help</i></label></Tooltip></div>
                  <div
                    className="col s12 m6 right-align center">{moment(settlementUserIdAffiliateData.settlementImportantDateDto.optOutDeadline).format('MM-DD-YYYY') === 'Invalid date' ? 'TBD' : moment(settlementUserIdAffiliateData.settlementImportantDateDto.optOutDeadline).format('MM-DD-YYYY')}</div>
                </li>
                <li className='timeline-text' style={{ display: (settlementUserIdAffiliateData.settlementImportantDateDto.hideFairnessHearing === 1) ? "none" : "inline-block" }} >
                  <div className="col s12 m6 left-align center"><span>Fairness Hearing</span> <Tooltip id="tooltip-icon" title="When an antitrust or class-action lawsuits is settled, there are often thousands or even millions of class members. The trial judge in many cases holds a fairness hearing to determine if the settlement is fair."><label className="q-icon"> <i className="small material-icons">help</i></label></Tooltip></div>
                  <div
                    className="col s12 m6 right-align center">{moment(settlementUserIdAffiliateData.settlementImportantDateDto.fairnessHearing).format('MM-DD-YYYY') === 'Invalid date' ? 'TBD' : moment(settlementUserIdAffiliateData.settlementImportantDateDto.fairnessHearing).format('MM-DD-YYYY')}</div>
                </li>
                <li className='timeline-text' style={{ display: (settlementUserIdAffiliateData.settlementImportantDateDto.hideClaimPeriodEnd === 1) ? "none" : "inline-block" }}>
                  <div className="col s12 m6 left-align center"><span>Claim Filing</span> <Tooltip id="tooltip-icon" title="Claim Period"><label className="q-icon"> <i className="small material-icons">help</i></label></Tooltip></div>
                  <div
                    className="col s12 m6 right-align center">{moment(settlementUserIdAffiliateData.settlementImportantDateDto.claimPeriodStart).format('MM-DD-YYYY') === 'Invalid date' ? 'TBD' : moment(settlementUserIdAffiliateData.settlementImportantDateDto.claimPeriodStart).format('MM-DD-YYYY')} - {moment(settlementUserIdAffiliateData.settlementImportantDateDto.claimPeriodEnd).format('MM-DD-YYYY') === 'Invalid date' ? 'TBD' : moment(settlementUserIdAffiliateData.settlementImportantDateDto.claimPeriodEnd).format('MM-DD-YYYY')}</div>
                </li>

                <li className='timeline-text' style={{ display: (settlementUserIdAffiliateData.settlementImportantDateDto.hideFundsDisbursement === 1) ? "none" : "inline-block" }} >
                  <div className="col s12 m6 left-align center"><span>Funds Disbursement</span> <Tooltip id="tooltip-icon" title="Once a settlement concludes and the submitted claims have been reviewed, audited, evaluated for their pro rata payment, and all objections and appeals are done, the court will receive and eventually approve a Motion to Distribute."><label className="q-icon"> <i className="small material-icons">help</i></label></Tooltip></div>
                  <div
                    className="col s12 m6 right-align center">{moment(settlementUserIdAffiliateData.settlementImportantDateDto.fundsDisbursement).format('MM-DD-YYYY') === 'Invalid date' ? 'TBD' : moment(settlementUserIdAffiliateData.settlementImportantDateDto.fundsDisbursement).format('MM-DD-YYYY')}</div>
                </li> */}

              </ul>
            </div>
          </div>
        )}
        {value === 3 && (
          <TabContainer>
            <div className="timeline row">
              {typeof getAllSettlementListOfUserByIdForGroupData !== "undefined" ? (
                <div>
                  {typeof getAllSettlementListOfUserByIdForGroupData.faqDtoList !==
                    "undefined" ? (
                      <div>
                        {getAllSettlementListOfUserByIdForGroupData.faqDtoList.length > 0 ? (
                          <div>
                            {getAllSettlementListOfUserByIdForGroupData.faqDtoList.map(
                              (s, idx) => (
                                <ExpansionPanel
                                  key={idx}
                                  className="margin-top-setting"
                                >
                                  <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                  >
                                    <Typography>{s.question}</Typography>
                                  </ExpansionPanelSummary>
                                  <ExpansionPanelDetails>
                                    <Typography>
                                      {" "}
                                      <div className="user-data__row">
                                        {" "}
                                        {s.answer}{" "}
                                      </div>
                                    </Typography>
                                  </ExpansionPanelDetails>
                                </ExpansionPanel>
                              )
                            )}
                          </div>
                        ) : (
                            <ul>
                              <li>No FAQ available.</li>
                            </ul>
                          )}
                      </div>
                    ) : (
                      <ul>
                        <li>No FAQ available.</li>
                      </ul>
                    )}
                </div>
              ) : (
                  <ul>
                    <li>No FAQ available.</li>
                  </ul>
                )}
            </div>
            <ExpansionPanel className="margin-top-setting">
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Document</Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <Typography>
                  {
                    //   settlementDocumentDtoList1 &&
                    // settlementDocumentDtoList1 !== undefined
                    //   ? settlementDocumentDtoList1.map((doc, idx) => (
                    //       <span
                    //         key={idx.toString()}
                    //         className="documents"
                    //         style={{ width: "100%" }}
                    //       >
                    //         <a target="_blank" href={doc.documentFilePath}>
                    //           {" "}
                    //           {doc.name
                    //             .split(".")
                    //             .slice(0, -1)
                    //             .join(".")}
                    //         </a>
                    //         <br />
                    //       </span>
                    //     ))
                    //   : "No recods found"
                  }
                  {(getAllSettlementListOfUserByIdForGroupData.settlementDocumentDtoList !== undefined) ? getAllSettlementListOfUserByIdForGroupData.settlementDocumentDtoList.map((doc, idx) => (
                    <div key={idx.toString()} className="documents" style={{ width: '100%' }}>
                      <a target="_blank" href={doc.documentFilePath}> {doc.name.split('.').slice(0, -1).join('.')}</a>
                    </div>
                  )) : "No recods found"}
                </Typography>
              </ExpansionPanelDetails>
            </ExpansionPanel>
            <ExpansionPanel className="margin-top-setting">
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Required Document</Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <Typography>
                  {/* {settlementRequiredDocumentDtoList &&
                  settlementRequiredDocumentDtoList !== undefined
                    ? settlementRequiredDocumentDtoList.map((doc, idx) => (
                        <span
                          key={idx.toString()}
                          className="documents"
                          style={{ width: "100%" }}
                        >
                          {`${doc.name} - `}
                          {doc.mandatory === 1 ? "Required" : "Not Required"}
                          <br />
                        </span>
                      ))
                    : "No recods found"} */}
                  {(getAllSettlementListOfUserByIdForGroupData.settlementRequiredDocumentDtoList !== undefined) ? getAllSettlementListOfUserByIdForGroupData.settlementRequiredDocumentDtoList.map((doc, idx) => (
                    <div key={idx.toString()} className="documents" style={{ width: '100%' }}>
                      <Typography>
                        {doc.name} - {(doc.mandatory === 1) ? "Required" : "Not Required"}
                      </Typography>
                    </div>
                  )) : "No recods found"}
                </Typography>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </TabContainer>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getAllSettlementListOfUserById,
      getAllSettlementListOfUserByIdForGroup,
      getBarGraphDataForDashboard
    },
    dispatch
  );
export default windowSize(connect(
  mapStateToProps,
  mapDispatchToProps
)(dashboardSettlementDetailsByGroups));
